import { Box, Typography } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";

function RenderRte(props: PropsType) {
  const element = useRef<HTMLDivElement | null>(null);
  const [displayText, setDisplayText] = useState<string | undefined>(props.rte);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  useEffect(() => {
    if (props.rte) {
      const words = props.rte.split(/\s+/);
      const wordLimit = 20;
      const previewLimit = 20;

      if (words.length > wordLimit) {
        const truncated = words.slice(0, previewLimit).join(" ") + "...";
        setDisplayText(truncated);
      } else {
        setDisplayText(props.rte);
      }
    }
  }, [props.rte]);

  const toggleContent = () => {
    setIsExpanded((prev) => !prev);
  };

  // لو noToggle مفعّلة، النص يفضل مقصوص دايمًا
  const showFull = isExpanded && !props.noToggle;

  if (props.more) {
    return (
      <Box>
        <div
          ref={element}
          dangerouslySetInnerHTML={{
            __html: showFull ? props.rte || "" : displayText || "",
          }}
        />
        {props.rte && props.rte.split(/\s+/).length > 20 && (
          <Typography
            sx={{
              marginTop: "4px",
              cursor: "pointer",
              fontWeight: "700",
              textDecoration: "underline",
            }}
            // من غير onClick لما noToggle، فالضغطة توصل للكارت وتفتح الصفحة
            onClick={props.noToggle ? undefined : toggleContent}
          >
            {showFull ? "See less" : "See more"}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <div ref={element} dangerouslySetInnerHTML={{ __html: props.rte || "" }} />
  );
}

export default RenderRte;

type PropsType = {
  rte?: string;
  more?: boolean;
  noToggle?: boolean; // true: "See more" شكل بس والضغطة تروح للكارت
};